'use strict';

require('babel-polyfill');

require('./index');


//////////////////
// WEBPACK FOOTER
// ./src/client/entry.js
// module id = 0
// module chunks = 0